import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface SupportModalContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const SupportModalContext = createContext<SupportModalContextType | null>(null);

export function SupportModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <SupportModalContext.Provider value={{ isOpen, open, close }}>
      {children}
    </SupportModalContext.Provider>
  );
}

export function useSupportModal() {
  const ctx = useContext(SupportModalContext);
  if (!ctx) throw new Error('useSupportModal must be used within SupportModalProvider');
  return ctx;
}
